import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  Renderer2,
  ViewChild,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { LoginService } from '../login/service/login.service';
import { NotifierService } from '../../services/Notifierservice';
import validationform from '../../validation/validationform';
import Validation from '../../validation/confirm-password-validation';
@Component({
  standalone: false,
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent implements OnInit {
  spinner: boolean = false;
  otpInput: any;
  getEmailVerifyResponseData: any;
  otpVerifiedData: any = [];
  submitted: boolean = false;
  isText = false;
  type: string = 'password';
  eyeIcon = 'fa-eye-slash';
  passwordIcon = 'fa fa-lock';
  forgotPasswordForm: FormGroup = new FormGroup({});
  showVerifyForm: string = 'forgotPassword';
  passwordForm: FormGroup = new FormGroup({});
  otpForm: FormGroup = new FormGroup({});
  postData = {
    email: '',
    encrypted_data: '',
    pass_phrase: "6389U%$B*P*-'TD5",
    salt: "`W/Q`,1/N.CG'%3I",
  };

  otpFormSubmit: boolean = false;

  @ViewChild('verifyOTP') verifyOTP!: ElementRef;
  @ViewChild('verifyOTPError') verifyOTPError!: ElementRef;
  @ViewChild('verifyOTPBtn') verifyOTPBtn!: ElementRef;

  @Output() formChange: EventEmitter<any> = new EventEmitter();

  private readonly notifier: NotifierService;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly service: LoginService,
    private readonly notifierService: NotifierService,
    private readonly renderer: Renderer2,
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: [
        null,
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
          ),
        ],
      ],
    });
    this.passwordForm = this.formBuilder.group(
      {
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(40),
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9\s])\S{8,}$/,
            ),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      {
        validators: [Validation.match('password', 'confirmPassword')],
      },
    );

    this.otpForm = this.formBuilder.group({
      userOTP: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.passwordForm.controls;
  }

  get verifyValidate() {
    return this.otpForm.controls;
  }

  submitOtp() {
    if (this.spinner) return;
    this.spinner = true;
    this.otpFormSubmit = true;

    if (this.otpForm.invalid) {
      this.spinner = false;
      return;
    }

    const email = localStorage.getItem('loginuser') ?? '';
    const otp = this.otpForm.value['userOTP']?.toString().trim();

    this.service.resetVerifyOtpFlow(email, otp).subscribe({
      next: (response: any) => {
        sessionStorage.setItem('isLoggedIn', 'true');
        this.showVerifyForm = 'otp';
        this.spinner = false;
      },
      error: (err) => {
        console.error(err);
        this.spinner = false;
      },
    });
  }

  async resetPassword(): Promise<void> {
    if (this.spinner) return;
    this.submitted = true;
    if (this.passwordForm.invalid) return;

    const values = this.passwordForm.value;
    const email = localStorage.getItem('loginuser') ?? '';
    const password = values.password;

    this.spinner = true;

    try {
      const possible =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const passPhrase = this.makeRandom(16, possible);
      const salt = this.makeRandom(16, possible);
      const enc = new TextEncoder();

      const keyMaterial = await crypto.subtle.importKey(
        'raw',
        enc.encode(passPhrase),
        { name: 'PBKDF2' },
        false,
        ['deriveKey'],
      );

      const aesKey = await crypto.subtle.deriveKey(
        {
          name: 'PBKDF2',
          salt: enc.encode(salt),
          iterations: 100_000,
          hash: 'SHA-256',
        },
        keyMaterial,
        { name: 'AES-GCM', length: 256 },
        false,
        ['encrypt'],
      );

      const iv = crypto.getRandomValues(new Uint8Array(12));
      const ciphertextBuffer = await crypto.subtle.encrypt(
        { name: 'AES-GCM', iv },
        aesKey,
        enc.encode(password),
      );

      const combined = new Uint8Array(
        iv.byteLength + ciphertextBuffer.byteLength,
      );
      combined.set(iv, 0);
      combined.set(new Uint8Array(ciphertextBuffer), iv.byteLength);
      const encryptedData = btoa(
        Array.from(combined)
          .map((b) => String.fromCharCode(b))
          .join(''),
      );

      const formEncrypt = {
        email: email.trim(),
        encrypted_data: encryptedData,
        salt: salt,
        pass_phrase: passPhrase,
      };

      this.service.postPassword(formEncrypt).subscribe({
        next: (response: any) => {
          this.showVerifyForm = 'passwordSuccess';
          this.notifier.notify(
            'default',
            response['result'] ?? 'Password reset successful.',
          );
          this.spinner = false;
          this.submitted = false;
          this.isText = false;
        },
        error: (err: any) => {
          console.error(err);
          this.spinner = false;
        },
      });
    } catch (error) {
      console.error('Encryption error:', error);
      this.spinner = false;
    }
  }

  hideShowPassword(): void {
    this.isText = !this.isText;

    this.eyeIcon = this.isText ? 'fa-eye' : 'fa-eye-slash';
    this.type = this.isText ? 'text' : 'password';
  }

  forgotPasswordFun() {
    if (this.spinner) return;
    if (this.forgotPasswordForm.valid) {
      this.spinner = true;
      const email = this.forgotPasswordForm.controls['email'].value; // grab email

      this.service.forgotPasswordRest(email).subscribe({
        next: (respone: any) => {
          this.spinner = false;
          localStorage.setItem('loginuser', email);
          this.notifier.notify(
            'default',
            'An OTP has been sent to your email.',
          );
          this.showVerifyForm = 'verify';
        },
        error: (err) => {
          this.spinner = false;
        },
      });
    } else {
      validationform.ValidateAllFormFields(this.forgotPasswordForm);
    }
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.passwordForm.invalid) {
      return;
    }

    const email = localStorage.getItem('loginuser') ?? '';
    const otp = this.otpForm.value['userOTP']?.toString().trim();

    this.spinner = true;

    this.service.verifyOtpFlow(email, otp).subscribe({
      next: (response: any) => {
        sessionStorage.setItem('isLoggedIn', 'true');
        this.showVerifyForm = 'passwordSuccess';
        this.notifier.notify(
          'default',
          response['result'] ?? 'Password reset successful.',
        );
        this.spinner = false;
        this.submitted = false;
        this.isText = false;
      },
      error: (err) => {
        console.error(err);
        this.spinner = false;
      },
    });
  }

  makeRandom(lengthOfCode: number, possible: string) {
    let text = '';
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  verifyOTPFormValidate() {
    this.renderer.setStyle(
      this.verifyOTPError.nativeElement,
      'display',
      'none',
    );
    this.renderer.setAttribute(
      this.verifyOTPBtn.nativeElement,
      'disabled',
      'true',
    );
    this.renderer.listen(
      this.verifyOTP.nativeElement,
      'input',
      (event: any) => {
        let pattern = /^[0-9]\d*$/;
        let inputvalue: any = event.target.value;
        if (!pattern.test(inputvalue)) {
          this.renderer.setStyle(
            this.verifyOTPError.nativeElement,
            'display',
            'block',
          );
          this.renderer.setAttribute(
            this.verifyOTPBtn.nativeElement,
            'disabled',
            'true',
          );
          setTimeout(() => {
            this.verifyOTP.nativeElement.value = '';
          }, 1500);
        } else {
          this.renderer.setStyle(
            this.verifyOTPError.nativeElement,
            'display',
            'none',
          );
          this.renderer.removeAttribute(
            this.verifyOTPBtn.nativeElement,
            'disabled',
          );
        }
      },
    );
  }

  goBack() {
    this.formChange.emit('login');
  }
}
